import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { TokenService } from '@lingoking-node-apps/api'
import { useAuthStore } from '@/stores/auth'
import productRoutes from './products'
import discountRoutes from './discounts'
import customerRoutes from './customers'
import companyRoutes from './companies'
import itemRoutes from './items'
import cartRoutes from './carts'
import feeGroups from './fee-groups'
import tagRoutes from './tags'
import linguists from './linguists'
import jobDefinitionRoutes from './job-definitions'
import deadlineDefinitionRoutes from './deadline-definitions'
import jobRoutes from './jobs'
import howToTips from './how-to-tips'
import financeRoutes from './finance'
import quoteRoutes from './quotes'
import emailTemplateRoutes from './email-templates'

const routes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'home',
    meta: {
      title: 'home'
    },
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: {
      title: 'login',
      public: true
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/LogoutView.vue'),
    meta: {
      title: 'logout'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: () => import('@/views/PageNotFoundView.vue'),
    meta: {
      title: 'not_found'
    }
  },
  ...productRoutes,
  ...discountRoutes,
  ...customerRoutes,
  ...companyRoutes,
  ...itemRoutes,
  ...cartRoutes,
  ...feeGroups,
  ...tagRoutes,
  ...linguists,
  ...deadlineDefinitionRoutes,
  ...howToTips,
  ...jobDefinitionRoutes,
  ...jobRoutes,
  ...financeRoutes,
  ...quoteRoutes,
  ...emailTemplateRoutes
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  if (to.meta.title) {
    document.title = `Lingoking - backoffice - ${to.meta.title}`
  }

  const auth = useAuthStore()

  // JTW:
  const isAuthenticated = TokenService.getAccessToken()

  // load profile:
  if (isAuthenticated && !auth.user) {
    await auth.profile()
  }

  return validateRoute(to, isAuthenticated)
})

function validateRoute(to: any, isAuthenticated: any) {
  const auth = useAuthStore()

  const authRequired = !to.meta.public

  // auth required routes:
  if (authRequired && !isAuthenticated) {
    auth.returnUrl = to.fullPath

    return '/login'
  }

  // already logged in:
  if (to.name == 'login' && isAuthenticated) {
    return '/'
  }
}

export default router
